const  router = [
	{
		path: "/appointment/layout",
		component: () => import('../../../pages/appointment/Layout.vue'),
		meta: {title: '预约排班'},
		name: 'appointment_layout',
		children:[
			{
				path: "/appointment",
				component: () => import('../../../pages/appointment/Technician.vue'),
				meta: {title: '技师管理', type:'m', permission: 'appointmentIndex'},
				//name: 'appointment_index'
				name: 'appointmentIndex'
			},
			{
				path: "/appointment/technicianDetail",
				component: () => import('../../../pages/appointment/TechnicianDetail.vue'),
				meta: {title: '技师详情', type:'c', permission: 'appointment_index_detail'},
				name: 'appointment_index_detail'
			},
			{
				path: "/appointment/order",
				component: () => import('../../../pages/appointment/Order.vue'),
				meta: {title: '预约订单', type:'c', permission: 'appointment_order'},
				name: 'appointment_order'
			},
			{
				path: "/appointment/kanban",
				component: () => import('../../../pages/appointment/KanbanNew.vue'),
				meta: {title: '预约看板', type:'c', permission: 'appointment_kanban'},
				name: 'appointment_kanban'
			},
			{
				path: "/appointment/shezhi",
				component: () => import('../../../pages/appointment/Setting.vue'),
				meta: {title: '预约设置', type:'c', permission: 'appointment_shezhi'},
				name: 'appointment_shezhi'
			},
			{
				path: "/appointment/technicianScheduling",
				component: () => import('../../../pages/appointment/TechnicianScheduling.vue'),
				meta: {title: '技师排班', type:'c', permission: 'appointment_technician_scheduling'},
				name: 'appointment_technician_scheduling'
			},
			{
				path: "/appointment/performanceType",
				component: () => import('../../../pages/appointment/PerformanceType.vue'),
				meta: {title: '业绩类型', type:'c', permission: 'appointment_performance_type'},
				name: 'appointment_performance_type'
			},
			{
				path: "/appointment/performanceApproval",
				component: () => import('../../../pages/appointment/PerformanceApproval.vue'),
				meta: {title: '业绩核准', type:'c', permission: 'appointment_performance_approval'},
				name: 'appointment_performance_approval'
			},
			{
				path: "/appointment/employeePerformance",
				component: () => import('../../../pages/appointment/EmployeePerformance.vue'),
				meta: {title: '员工业绩', type:'c', permission: 'appointment_employee_performance'},
				name: 'appointment_employee_performance'
			},
		],
	}
];

export default router